import React from "react";
import {UserOutlined} from '@ant-design/icons'
import * as S from "./ChatAnswer.styles"


const ChatAnswer = ({answer}: { answer: string }) => {


    return (
        <S.AnswerCard size="small" title={
            <S.CardHeader>
                <span><UserOutlined/> You say:</span>

            </S.CardHeader>
        }>
            <span> You have selected the following answer: "{answer}" </span>
        </S.AnswerCard>
    )
}

export default ChatAnswer;
